import React, { useEffect, useState } from 'react';
import { CircularProgress, Paper, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';
import WLSTable, { useStyles as useTableStyles } from 'components/WLSTable.jsx';
import { dateFromTS } from 'components/order_list/helpers';
import { getErrorOrders, resetErrorOrders, assignSapId } from 'library/order/errors';
import { connect } from 'react-redux';
import { notnull } from 'library/wls_helper';

const useStyles = makeStyles((theme) => ({
  main: {
    padding: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    fontSize: '1.2rem',
  },
  loading_spinner: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
}));

function mapStateToProps(state) {
  const { dispatch } = state;
  return { dispatch };
}

function ErrorOrders({ dispatch }) {
  const classes = useStyles();
  const tableClasses = useTableStyles();
  const [orders, setOrders] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [confirmOrder, setConfirmOrder] = useState(null);
  const [isInSap, setIsInSap] = useState(null);

  const loadOrders = () => {
    setLoaded(false);
    getErrorOrders().then((res) => {
      setLoaded(true);
      if (Array.isArray(res)) {
        setOrders(res);
      } else {
        dispatch({ type: 'SHOW_MESSAGE', payload: { severity: 'error', message: res.error || 'Failed to load error orders' } });
      }
    });
  };

  useEffect(() => {
    loadOrders();
    // eslint-disable-next-line
  }, []);

  const onResetConfirm = () => {
    resetErrorOrders([confirmOrder.id]).then((res) => {
      setConfirmOrder(null);
      if (res.status === 'success') {
        dispatch({ type: 'SHOW_MESSAGE', payload: { severity: 'success', message: 'Order reset to open state' } });
        loadOrders();
      } else {
        dispatch({ type: 'SHOW_MESSAGE', payload: { severity: 'error', message: res.error || 'Reset failed' } });
      }
    });
  };

  const onAssignSapId = (orderId, sapId) => {
    assignSapId(orderId, sapId).then((res) => {
      setIsInSap(null);
      if (res.status === 'success') {
        dispatch({ type: 'SHOW_MESSAGE', payload: { severity: 'success', message: 'SAP ID assigned successfully' } });
        loadOrders();
      } else {
        dispatch({ type: 'SHOW_MESSAGE', payload: { severity: 'error', message: res.error || 'Failed to assign SAP ID' } });
      }
    });
  };

  const salesOrgContent = (order) =>
    notnull(order.channel) && notnull(order.sales_organization)
      ? `${order.sales_organization}/${order.channel}`
      : '—';

  const columns = [
    {
      disablePadding: true, id: 'customer', align: 'left', label: 'Customer',
      rowContent: (c) => <Link href={'/admin/user/' + c.customer.id}>{c.customer.name}</Link>,
    },
    { disablePadding: true, id: 'catalog', align: 'left', label: 'Catalog' },
    { disablePadding: true, id: 'seller', align: 'left', label: 'Agent' },
    { disablePadding: true, id: 'sales_org', size: 'small', align: 'left', label: 'SO', rowContent: salesOrgContent },
    { disablePadding: true, id: 'address_id', size: 'small', align: 'left', label: 'Ship' },
    { disablePadding: true, id: 'items_count', size: 'small', align: 'left', label: 'Items' },
    {
      disablePadding: true, id: 'total_price', size: 'small', align: 'right', label: 'Amount',
      rowContent: (c) => `${(c.total_price || 0).toFixed(2)} ${c.currency || ''}`,
    },
    {
      disablePadding: true, id: 'created', align: 'right', label: 'Created',
      rowContent: (c) => dateFromTS(c.created),
    },
    {
      disablePadding: true, id: 'actions', size: 'small', align: 'center', label: 'Actions', hideSort: true,
      rowContent: (c) => (
        <>
        <Button size="small" variant="outlined" color="primary" onClick={() => setIsInSap(c)}>
          In SAP
        </Button>
        <Button size="small" variant="outlined" color="primary" onClick={() => setIsInSap(c)}>
          Resend
        </Button>
        </>
      ),
    },
  ];

  return (
    <div className={classes.main}>
      <div className={classes.title}>SAP Error Orders</div>

      <Paper style={{ display: loaded ? 'none' : 'block' }} className={classes.loading_spinner}>
        <CircularProgress />
      </Paper>

      <WLSTable hidden={!loaded} rows={orders} columns={columns} classes={tableClasses} shouldShowRow={() => true} />

      <Dialog open={Boolean(isInSap)} onClose={() => setIsInSap(null)}>
        <DialogTitle>Check SAP</DialogTitle>
        <DialogContent>
          Check if order <strong>{isInSap?.name}</strong> is in SAP?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsInSap(null)} color="secondary">Cancel</Button>
          <Button onClick={onResetConfirm} color="primary">Reset</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default connect(mapStateToProps)(ErrorOrders);
